import request from "../utils/request";

export const getMarkets = '/market/'

export function modifyMarket(data: any) {
    return request.request({
        url: '/market/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteMarket(id: number) {
    return request.request({
        url: '/market/',
        method: 'delete',
        params: {marketId: id}
    })
}
